import React, { useState } from 'react';
import { resyncAllRecruits } from '../../services/algolia';

function ImportResyncRecruits() {
    const [running, setRunning] = useState(false);
    const [progress, setProgress] = useState(null);
    const [status, setStatus] = useState(null);

    async function runResync() {
        setRunning(true);
        setStatus(null);
        setProgress({ processed: 0, total: null });

        try {
            const processed = await resyncAllRecruits((processedCount, total) => {
                setProgress({ processed: processedCount, total });
            });
            setStatus(`Done! Resynced ${processed} recruits.`);
        } catch (error) {
            console.log('Error resyncing recruits: ', error);
            setStatus('Error resyncing recruits. Check the console for details.');
        } finally {
            setRunning(false);
        }
    }

    return (
        <div>
            <h3 style={{ marginBottom: '20px' }}>
                Resync Recruits (No Downtime)
            </h3>

            <p>
                Refreshes every recruit's record in the PROD_RECRUIT_ATHLETE index
                in place &mdash; including coach/contact info sourced from the
                HighSchools table &mdash; without ever clearing the index first.
                Unlike "Build Recruit Index," search stays fully live the entire
                time this runs.
            </p>

            <p>
                Note: because it never clears the index, this won't remove entries
                for recruits that were deleted from the database or that no longer
                qualify for the index. Use "Build Recruit Index" for that kind of
                full cleanup instead.
            </p>

            <p>
                This covers every recruit (~70k), so it will take a while. Keep
                this tab open until it finishes.
            </p>

            <p>
                <button
                    style={{ marginTop: '5px' }}
                    className="btn btn-success"
                    onClick={() => runResync()}
                    disabled={running}
                >
                    {running ? 'Resyncing…' : 'Resync Recruits →'}
                </button>
            </p>

            {progress && (
                <p>
                    Processed {progress.processed}
                    {progress.total ? ` of ${progress.total}` : ''} recruits...
                </p>
            )}

            {status && <p>{status}</p>}
        </div>
    );
}

export default ImportResyncRecruits;
